import React, { useState } from 'react';

import Dialog from 'components/Dialog';
import FileUploader from './FileUploader';
import ErrorDisplay from 'components/ErrorDisplay';

import { StepInformation } from './Styled';

export const useUploadDialog = (onUpload, clearError) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    clearError && clearError();
    setOpen(false);
  };

  const handleOpen = () => {
    clearError && clearError();
    setOpen(true);
  };

  const handleUpload = (file, description) => {
    onUpload(file, description);
  };

  const renderDialog = ({ loading, errorMessage }) => (
    <Dialog
      open={open}
      hideActions
      loading={loading}
      showFloatingCancel
      onClose={handleClose}
      title="Upload Document"
    >
      <StepInformation>
        Select and upload a document to the order below.
      </StepInformation>
      <FileUploader handleUpload={handleUpload} />
      {!loading && <ErrorDisplay message={errorMessage} />}
    </Dialog>
  );

  return [renderDialog, handleOpen, handleClose];
};

export default useUploadDialog;
